import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from "react-intl";

import SalesLineChart from "./SalesLineChart";
import TurnoverSubtitle from "./TurnoverSubtitle";

TurnoverGraph.propTypes = {
    online: PropTypes.object,
    physical: PropTypes.object,
    onlineCountTotal: PropTypes.number,
    unit: PropTypes.oneOf(["day", "month", "year"]).isRequired,
    unitParser: PropTypes.oneOf(["YYYY", "YYYYMM", "YYYYMMDD"]).isRequired,
    unitTooltip: PropTypes.oneOf(["YYYY", "MMMM YYYY", "D MMMM YYYY"]).isRequired,
    loading: PropTypes.bool,
    currency: PropTypes.string
};

function TurnoverGraph({online, physical, onlineCountTotal, unit, unitParser, unitTooltip, loading, currency}) {
    const intl = useIntl();

    // Revenue across all statuses (pending, reserved, to-ship, confirmed, canceled, returned, etc.)
    const onlineTurnoverTotal = online.turnoverTotal ?? 0;

    // Average cart computed client-side (not provided by the backend)
    const averageCart = onlineCountTotal > 0 ? onlineTurnoverTotal / onlineCountTotal : 0;

    const turnoverKpi = onlineTurnoverTotal
        ? intl.formatNumber(onlineTurnoverTotal, { style: "currency", currency: currency ?? "EUR", maximumFractionDigits: 2 })
        : null;

    return (
        <SalesLineChart
            title={''}
            kpiValue={turnoverKpi}
            subtitle={(
                <TurnoverSubtitle
                    averageCart={averageCart}
                    onlineTurnoverTotal={onlineTurnoverTotal}
                    currency={currency}
                />
            )}
            onlineData={online.turnoverGraph}
            physicalData={physical.turnoverGraph}
            onlineLegend={intl.formatMessage({ id: "dashboard.graph.legend.online" })}
            physicalLegend={intl.formatMessage({ id: "dashboard.graph.legend.physical" })}
            unit={unit}
            unitParser={unitParser}
            unitTooltip={unitTooltip}
            loading={loading}
        />
    );
}

export default TurnoverGraph;
